import { Component, Input, OnInit } from '@angular/core';
import { ShowcaseStateService } from '@app/core/services/showcase-state.service';

@Component({
  selector: 'app-top-horizontal-list',
  templateUrl: './top-horizontal-list.component.html',
  styleUrls: ['./top-horizontal-list.component.scss']
})
export class TopHorizontalListComponent implements OnInit {
  @Input() title = 'Recommended for you';
  @Input() items = [];
  @Input() amount = 2;
  @Input() mode = 1;
  @Input() showcase = false;
  @Input() showStats = false;
  @Input() pageType = '';
  @Input() loading = false;

  get expanded() { return this.showcaseState.expanded; }
  set expanded(val: boolean) { this.showcaseState.expanded = val; }

  constructor(private showcaseState: ShowcaseStateService) {}

  ngOnInit(): void {
    if (this.showcase) {
      this.amount = this.showcaseState.expanded ? 24 : 6;
    }
  }

  toggleExpand() {
    this.showcaseState.expanded = !this.showcaseState.expanded;
    this.amount = this.showcaseState.expanded ? 24 : 6;

    if (!this.showcaseState.expanded) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }
}
